import { Injectable } from '@angular/core';
import { BaseService } from './loja/base.service';
import { Http } from '@angular/http';

@Injectable()
export class GlobalService extends BaseService {

    public readonly EDUCADOR=15;
    public readonly EMPRESA=16;
    public readonly ALUNO=17;


    public loggedUser = null;
    public token = null;

    constructor(public http: Http) {
        super(http, 'api', 'v2');
        
        let user:any = sessionStorage.getItem("loggedUser");
        if (user) {
            user = JSON.parse(user);
            this.loggedUser = user.data;
        }

        this.token = sessionStorage.getItem("token");

    }

}



// WEBPACK FOOTER //
// ./src/app/services/global.services.ts